// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N30, N90 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ContentWrapper = styled.div({
  display: 'flex',
  height: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchFooterLabelWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  gap: "var(--ds-space-025, 2px)",
  color: "var(--ds-text-subtle, ".concat(N90, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchFooterLabel = styled.div({
  backgroundColor: "var(--ds-background-neutral, ".concat(N30, ")"),
  padding: "0px ".concat("var(--ds-space-025, 2px)"),
  borderRadius: '4px'
});